import { useEffect, useRef, type ReactNode } from 'react';
import { Button } from './Button';

type Props = {
  open: boolean;
  title: ReactNode;
  body?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: 'primary' | 'danger';
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отмена',
  confirmVariant = 'primary',
  onConfirm,
  onCancel,
}: Props) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      onClose={onCancel}
      className={[
        'p-0 m-auto rounded-[var(--radius-md)] border border-[var(--color-border)]',
        'bg-[var(--color-surface)] text-[var(--color-text)] shadow-[var(--shadow-lg)]',
        'backdrop:bg-black/30',
        'max-w-md w-[90vw]',
      ].join(' ')}
    >
      <div className="p-6 space-y-4">
        <h3 className="font-display text-lg leading-tight">{title}</h3>
        {body && <div className="text-sm text-[var(--color-text-muted)]">{body}</div>}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </dialog>
  );
}
